var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "group_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#group_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M2.398 22.78c0-.688.177-1.301.532-1.84.354-.54.828-.96 1.42-1.259a20.572 20.572 0 0 1 3.823-1.434c1.281-.335 2.69-.503 4.224-.503 1.535 0 2.944.168 4.225.503 1.28.336 2.555.814 3.822 1.434.593.3 1.067.72 1.421 1.259.355.539.532 1.152.532 1.84v.938c0 .537-.197 1.009-.59 1.415-.395.407-.873.61-1.435.61H4.422c-.561 0-1.04-.196-1.433-.59a1.954 1.954 0 0 1-.591-1.435v-.939Zm22.15 2.964a4.231 4.231 0 0 0 .515-2.026v-1.103c0-.875-.213-1.709-.642-2.502-.428-.793-1.036-1.473-1.824-2.041.894.133 1.743.34 2.547.619.803.28 1.57.61 2.3.991.689.368 1.22.8 1.596 1.3a2.66 2.66 0 0 1 .562 1.633v1.103c0 .562-.197 1.04-.59 1.435a1.953 1.953 0 0 1-1.435.59h-3.028ZM12.399 15.59c-1.284 0-2.383-.457-3.296-1.371-.914-.914-1.371-2.013-1.371-3.296s.457-2.382 1.37-3.296c.914-.914 2.013-1.37 3.296-1.37 1.284 0 2.382.456 3.296 1.37.914.914 1.37 2.013 1.37 3.296s-.456 2.382-1.37 3.296c-.914.914-2.012 1.37-3.296 1.37Zm11.512-4.667c0 1.283-.457 2.382-1.37 3.296-.915.914-2.013 1.37-3.296 1.37a4.08 4.08 0 0 1-.575-.05 5.04 5.04 0 0 1-.574-.113 7.077 7.077 0 0 0 1.212-2.104c.283-.77.424-1.57.424-2.4 0-.83-.144-1.627-.432-2.391a7.706 7.706 0 0 0-1.204-2.11c.191-.069.383-.113.574-.134.192-.02.383-.03.575-.03 1.283 0 2.381.456 3.295 1.37.914.914 1.37 2.013 1.37 3.296Z",
    fill: "currentColor"
  }))));
};
export default SvgGroup;